<template>
	<span class="wauchat">
		<b-link :href="urlWhatapp+phone" target="_blank" v-if="whatsapp==0" @click="updateWappstatus(userId,listtype,phone)"><b-img  src="@/assets/whatsapp.svg" class="socialIcondiv--icon" width="25px;"></b-img></b-link> 
		<b-link :href="urlWhatapp+phone" target="_blank"  v-else @click="updateWappstatus(userId,listtype,phone)">
		<b-button pill variant="outline-primary" class="mr-1 icon-btn" ><i class="fa fa-whatsapp" aria-hidden="true" style="font-size:16px;" ></i></b-button> 
		</b-link>
	</span>
</template>
<script> 
/* const separator = {
  template: '<hr style="border-color: rgba(0, 0, 0, 0.1); margin: 20px;">'
}; */
	//var today 	= new Date();
	//var timenow = '?'+today.getHours()+ today.getMinutes()+today.getSeconds();
	
export default {
  name: 'MenuPanel',
  components: {
  
  },
  props: {
   userId:{type: Number},
   phone:{type: String},
   whatsapp:{type:Number},
   listtype:{type: String}
  },
  mounted(){
  //this.inLodcard;
  if(window.innerWidth < 700){
	//this.urlWhatapp='https://wa.me/send?text=&phone=918920670756';
	this.urlWhatapp='https://api.whatsapp.com/send?text=&phone=91';
 }
  
	
  },
  computed: {
    //
  },
  data() {
    return{
     collapsed: false,
	 urlWhatapp:'https://web.whatsapp.com/send?text=&phone=91',
	 updateWahtappUrluser: this.$root.WEBAPI+'secureapi/updateUserWhatsappStatus',
	 updateWahtappUrlmark: this.$root.WEBAPI+'secureapi/updateMarkWhatsappStatus',
	 updateWahtappUrlmarkcustomr: this.$root.WEBAPI+'secureapi/updateMarkCustomerWhatsappStatus',

    }
  },
  methods:{
	/* inLodcard(){
	this.cartHeader ='
	} */
	updateWappstatus(userIdl,listtypel,mobile){
		console.log(userIdl+'---'+listtypel);
		var self = this;
			var userId	= userIdl;
			
			var reqUri=  self.updateWahtappUrlmark;
			if(listtypel=='user'){
				reqUri= self.updateWahtappUrluser
			}
			if(listtypel=='markcustomr'){
				reqUri= self.updateWahtappUrlmarkcustomr
			}
			
			self.axios.post(reqUri, {
				userId:userId,
				mobile:mobile,
			})
			.then(function (response) {
				if(response.data.error == 0 || response.data.error == '0'){
						console.log('as');
				}
			})
			.catch(function (error) {
				alert(error);
			});
		
	
	},
	onToggleCollapse() {
			/* console.log('Ram Ram'+collapsed);
			this.collapsed = collapsed; */
			console.log('DataR'+this.collapsed);
			
			 if(this.collapsed){
				this.collapsed = false;
				
			 }else{
				this.collapsed = true;
				
			 }
			
			 /*this.posmenuProfile = collapsed;
			 this.navppnew = collapsed;
			 if(!collapsed){
				this.posmenu = true;
				
			 }else{
				this.posmenu = false;
				
			 }*/
		},
    
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style   scoped lang="scss">
	.regFlotig{
		.btn-primary{
			
			width: 40px;
			height: 40px;
			position: fixed;
			border-radius: 50%;
			bottom: 10px;
			right: 20px;
			border: 0px;
			z-index: 9;
			color: red;
			background: #fff;
			border: 1px solid #010e1d;
				 
		}
		
		.floating-action{
			margin: 10px 0px;
		}
		.btn-dark{
			font-size: 10px;
		}
		
		div.floating-action-menu.active > .action-menu{
			visibility: visible;
			transform: translate(0);
			opacity: 1;
			padding-bottom: 5px;
			max-height: 1000px;
			position: fixed;
			bottom: 41px;
			right: 0px;
			z-index: 999;
		}
		.iconPuser{
			font-size:20px;
		}
	
	
	
	
	div.floating-action-menu.active > .action-button > .btn-floating:hover {
			/*background-color: red;
			border-color: #ff4c3b;*/
			
			color: #fff;
		}
		div.floating-action-menu.active > .action-button > .btn-floating {
			
			color: #fff;
		}
		
		
		.btn-primary:focus{
			box-shadow: none;
		}
	
	
	}
	div.floating-action-menu > .action-menu {
            visibility: hidden;
            transform: translateY(65px);
            opacity: 0;
            max-height: 0;
            overflow: hidden;

            transition: all 300ms linear;
        }
        div.floating-action-menu.active > .action-menu {
            visibility: visible;
            transform: translate(0);
            opacity: 1;
            padding-bottom: 5px;
            max-height: 1000px;
        }

        div.floating-action-menu > .action-menu > .floating-action {
            padding-right: 0.45rem;
        }

        div.floating-action-menu > .action-menu .btn-floating,
        div.floating-action-menu > .action-menu .badge
        {
            transform: scale(0.4);
            transition: all 500ms ease-in-out;
        }
        div.floating-action-menu.active > .action-menu .btn-floating,
        div.floating-action-menu.active > .action-menu .badge
        {
            transform: scale(1);
        }

        div.floating-action-menu > .action-button > .btn-floating {
            transition: all 500ms linear;
        }
        div.floating-action-menu.active > .action-button > .btn-floating {
            background-color: #dc3545;
            border-color: #dc3545;
        }
        div.floating-action-menu.active > .action-button > .btn-floating:hover {
            background-color: #c82333;
            border-color: #bd2130;
        }

        div.floating-action-menu > .action-button > .btn-floating > i {
            transition: transform 500ms ease-in-out;
        }
        div.floating-action-menu.active > .action-button > .btn-floating > i {
            transform: rotate(-315deg);

        }
	.waimg{ width: 42px;
    margin-top: -3px;
    margin-left: -8px;
	}


</style>
